import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { MultiSelectButton } from '@modernhealth/vital-components';

import { MemberAvailability } from 'src/generated/webapp_gql';
import type { Dispatch } from 'src/config/rootStore';
import { getAvailability } from 'src/modules/user/selectors/userSelectors';
import { availabilityOptions } from 'src/shared/models/shared';

import type { QuestionnaireType } from 'src/modules/pathways/pages/PathwayCreateQuestionnairePage';

import { CreatePathwayQuestionnaireLayout } from './CreatePathwayQuestionnaireLayout';

interface Props {
    pathwayUuid: string;
    nextQuestionnaireType?: QuestionnaireType | undefined;
}

export const CreatePathwayQuestionnaireAvailability = ({
    pathwayUuid,
    nextQuestionnaireType,
}: Props) => {
    const dispatch = useDispatch<Dispatch>();
    const { t } = useTranslation();
    const userAvailablity = useSelector(getAvailability);
    const [availability, setAvailability] = useState<string[]>(userAvailablity ?? []);

    return (
        <CreatePathwayQuestionnaireLayout
            pathwayUuid={pathwayUuid}
            question={{
                title: t('pathways:onboarding.questionnaire.availability.subtitle'),
                description: t('pathways:onboarding.questionnaire.availability.description'),
            }}
            nextQuestionnaireType={nextQuestionnaireType}
            disabled={availability.length === 0}
            onSubmit={() =>
                dispatch.user.updateMemberProfile({
                    availability: availability as MemberAvailability[],
                })
            }
        >
            {availabilityOptions.map(value => {
                const checked = availability.includes(value);

                return (
                    <MultiSelectButton
                        key={value}
                        onClick={() => {
                            if (checked) {
                                setAvailability(ava => ava.filter(a => a !== value));
                            } else {
                                setAvailability(ava => [...ava, value]);
                            }
                        }}
                        active={checked}
                        text={t(
                            `providers:additional_info.availabilityTime.${value.toLowerCase()}`,
                        )}
                    />
                );
            })}
        </CreatePathwayQuestionnaireLayout>
    );
};
